<template>
    <div id="show">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div v-if="is_initialized">
            <div v-if="is_loading" class="ui active centered inline loader"></div>
            <table class="ui fixed table blue" v-else-if="operation.identity">
                <thead>
                    <tr>
                        <th :class="style.width < 767 ? '' : 'right aligned'">
                            <h3 class="ui header">{{ operation.number }}</h3>
                        </th>
                        <th colspan="4">

                        </th>
                        <th>
                            {{ human_datetime(operation.created_at) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 狀&emsp;&emsp;態 -->
                            {{ $t('models.attributes.operations.status') }}
                        </td>
                        <td colspan="5">
                            <span v-if="operation.is_done">
                                <i class="check icon"></i>
                                {{ $t('models.attributes.operations.is_done') }}
                                <!-- 已完成 -->
                            </span>
                            <span v-else>
                                <i class="play icon"></i>
                                {{ $t('ui.pages.operations.processing') }}
                                <!-- 處理中 -->
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 您的備註 -->
                            {{ $t('models.attributes.operations.your_note') }}
                        </td>
                        <td colspan="5">
                            {{ operation.customer_note || '-' }}
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 合&emsp;&emsp;約 -->
                            {{ $t('ui.pages.operations.contract') }}
                        </td>
                        <td colspan="5">
                            {{ operation.contract.name || '-' }}
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 託運文件 -->
                            {{ $t('models.attributes.operations.file') }}
                        </td>
                        <td colspan="5">
                            <a :href="operation.original_file_url">{{ operation.original_file_name }}</a>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 印出運單標籤 -->
                            {{ $t('ui.pages.operations.print_coew_waybill_labels') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <CoreWaybillsLabelSvg
                                :numbers="label_numbers"
                                :authentication_token="token"
                                :scope="'customer'"
                                :printing_type="printing_type_grouped_core_waybills"
                                :channel="print_label_channel"
                                :is_show_input="false"
                                >
                            </CoreWaybillsLabelSvg>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 印出託運總表 -->
                            {{ $t('ui.pages.operations.print_coew_waybill_checklist') }}
                        </td>
                        <td colspan="5">
                            <OrderSummary
                                :channel_name="'my_order_summaray'"
                                :default_search_params="{
                                    operation_identity: operation.identity,
                                    pagination: false,
                                }"
                                :title="$store.state.customer.customer.provider_node.company_short_name + '託運總表'"
                                :sub_title="$store.state.customer.customer.provider_node.website_url"
                                :customer_service_hotline="$store.state.customer.customer.provider_node.customer_service_hotline"
                                :logistician="{name: '9999999 配送人員'}"
                                :logo_url="'/images/' + $store.state.customer.customer.provider_node.company_en_name.replace(/(?:^|\.|\s?)([A-Z])/g, function (x,y){return '_' + y.toLowerCase()}).replace(/^_/, '') + '_logo.jpg'"
                                :show_buttons="true"
                                :show_contents="false"
                                :scope="'customer'"
                                >
                            </OrderSummary>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" class="x_scrollable">
                            <CoreWaybills
                                :default_search_params="{
                                    operation_identity: operation.identity,
                                }"
                                :columns="[{
                                    input_type: null,
                                    display_type: 'material',
                                    name: 'materials',
                                    // human_name: '類型',
                                    human_name: $t('models.materials'),
                                },
                                {
                                    input_type: 'text',
                                    display_type: 'text',
                                    name: 'number',
                                    // human_name: '單號',
                                    human_name: $t('models.attributes.core_waybills.number'),
                                },
                                {
                                    input_type: 'text',
                                    display_type: 'text',
                                    name: 'consignee_name',
                                    // human_name: '收件人姓名',
                                    human_name: $t('models.attributes.core_waybills.consignee_name'),
                                },
                                {
                                    input_type: 'number',
                                    display_type: 'text',
                                    name: 'weight_in_kilo',
                                    // human_name: '重量',
                                    human_name: $t('models.attributes.core_waybills.weight_in_kilo'),
                                },
                                {
                                    input_type: 'number',
                                    display_type: 'text',
                                    name: 'collection',
                                    // human_name: '代收貨款',
                                    human_name: $t('models.attributes.core_waybills.collection'),
                                },
                                {
                                    input_type: null,
                                    display_type: 'status',
                                    name: 'latest_status',
                                    // human_name: '貨況',
                                    human_name: $t('models.attributes.core_waybills.latest_status'),
                                },]"
                                :scope="'customer'"
                                >
                            </CoreWaybills>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="ui segment" v-if="operation.identity">
                <Comments :commentable_type="'Operation'" :commentable_identity="operation.identity" :scope="'customer'"></Comments>
            </div>
        </div>
        <div class="ui active inverted dimmer" v-else>
            <div class="ui text loader">{{ $t('ui.general.initializing') }}</div>
        </div>
    </div>
</template>

<script>
import CoreWaybillsLabelSvg from "@toolbox/core_waybills_label_svg/main.vue"
import OrderSummary from "@toolbox/order_summary/main.vue"
import Comments from "@toolbox/bulletin_board/comments.vue"
import CoreWaybills from "@toolbox/core_waybills/main.vue"
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "CustomerOperationsShow",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            operation: {},
            errors: [],
            print_label_channel: "operation_print_label_channel",
            label_urls_array: [],
        }
    },
    watch: {
        'label_urls_array' (to, from) {
            if (to.length > 0 && this.$route.query.print_label == true) {
                _.forEach(to, url => {
                    window.open(url, '_blank')
                })
            }
        }
    },
    created() {
        this.$bus.$on(this.print_label_channel, label_urls_array => {
            this.label_urls_array = label_urls_array
        })
    },
    mounted() {
        this.init()
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        material_grouped_core_waybills() {
            return _.groupBy(this.operation.core_waybills, 'material.class_name')
        },
        label_numbers() {
            let label_number_objects = []
            _.forEach(this.material_grouped_core_waybills.Waybill, (e) => {
                if (!isNaN(parseInt(e.note_2))) {
                    for (let i = 1; i <= parseInt(e.note_2); i++) {
                        label_number_objects.push(
                            {
                                number: e.number,
                                count: parseInt(e.note_2),
                                serial: i
                            }
                        )
                    }
                } else {
                    label_number_objects.push(
                        {
                            number: e.number,
                            count: 1,
                            serial: 1
                        }
                    )
                }
            })
            _.forEach(this.material_grouped_core_waybills.Goods, (e) => {
                if (!isNaN(parseInt(e.note_2))) {
                    for (let i = 1; i <= parseInt(e.note_2); i++) {
                        label_number_objects.push(
                            {
                                number: e.number,
                                count: parseInt(e.note_2),
                                serial: i
                            }
                        )
                    }
                } else {
                    label_number_objects.push(
                        {
                            number: e.number,
                            count: 1,
                            serial: 1
                        }
                    )
                }
            })
            return label_number_objects
        },
        printing_type_grouped_core_waybills() {
            let result = _.groupBy(this.operation.core_waybills, 'label_type')
            let key_names = Object.keys(result)
            return key_names[0] != "undefined" ? key_names[0] : null
        },
        token() {
            return localStorage.getItem("customer_authentication_token")
        },
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    resolve()
                })
                await this.fetch_operation()
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                switch (e) {
                    default:
                    console.log("init error: ")
                    console.log(e)
                }
            } finally {

            }
        },
        fetch_operation() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.customer.routes.api_v1_customer_operation).parse(
                {"operation_identity": this.$route.params.identity},
            )
            return axios.get(url, {headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.operation = response.data.operation
                    } else if (response.data.status == "failure") {
                        return Promise.reject(response.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        switch (error.response.status) {
                            default:
                            this.errors.push(error.response.status + ' ' + error.response.statusText)
                        }
                        // this.$noty.error('取得 訂單 失敗: ' + error.response.status + ' ' + error.response.statusText)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.operations'),
                                reason: ': ' + error.response.status + ' ' + error.response.statusText
                            })
                        )
                    } else if (error.errors) {
                        // this.$noty.error('取得 訂單 失敗: ' + error.errors)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.operations'),
                                reason: ': ' + error.errors
                            })
                        )
                    } else {
                        this.errors.push(this.$t('ui.general.server_offline'))
                        this.$noty.error(this.$t('ui.general.server_offline'))
                    }
                    // return Promise.reject(error)
                })
                .finally(() => {
                    this.is_loading = false
                })
        },
    },
    components: {
        CoreWaybillsLabelSvg,
        OrderSummary,
        Comments,
        CoreWaybills,
        ErrorMessages,
    }
}
</script>

<style scoped>
</style>
